(() => {
  'use strict';

  const THEME_ID = 187071463802;
  if (Number(window.Shopify?.theme?.id) !== THEME_ID) return;

  const BADGE_CLASS = 'amr-free-shipping-summary';
  const ACTIVE_CLASS = 'amr-free-shipping-active';
  let queued = false;

  function normalize(value) {
    return String(value || '')
      .replace(/ /g, ' ')
      .replace(/s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isFreeDelivery(value) {
    const text = normalize(value);
    if (!text) return false;
    return /^(?:free|gratuit|gratuite|مجاني|0(?:[.,]0+)?s*(?:dh|mad)?)$/i.test(text);
  }

  function createBadge() {
    const badge = document.createElement('div');
    badge.className = BADGE_CLASS;
    badge.lang = 'ar';
    badge.dir = 'rtl';
    badge.setAttribute('role', 'status');
    badge.setAttribute('aria-live', 'polite');

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 32 24');
    icon.setAttribute('aria-hidden', 'true');
    icon.classList.add('amr-free-shipping-icon');
    icon.innerHTML =
      '<path d="M2 5h16v12H2z"></path>' +
      '<path d="M18 9h6l5 5v3H18z"></path>' +
      '<circle cx="8" cy="20" r="2.5"></circle>' +
      '<circle cx="24" cy="20" r="2.5"></circle>' +
      '<path d="M0 9h7M0 13h5"></path>';

    const text = document.createElement('span');
    text.textContent = 'التوصيل مجاني';
    badge.append(icon, text);
    return badge;
  }

  function syncForm(form) {
    const shippingLine = form.querySelector('[data-checkout-line="shipping"]');
    const shippingValue = shippingLine?.querySelector('._rsi-modal-checkout-line-value');
    const summary =
      shippingLine?.closest('._rsi-build-block-totals-summary') ||
      form.querySelector('._rsi-build-block-totals-summary');
    if (!shippingValue || !summary) return;

    const free = isFreeDelivery(shippingValue.textContent);
    let badge = form.querySelector(':scope > .' + BADGE_CLASS);
    if (!badge) {
      badge = createBadge();
      badge.hidden = true;
    }
    if (badge.previousElementSibling !== summary) summary.after(badge);

    if (summary.hidden !== free) summary.hidden = free;
    if (badge.hidden === free) badge.hidden = !free;
    form.classList.toggle(ACTIVE_CLASS, free);
  }

  function enhance() {
    queued = false;
    document
      .querySelectorAll('#_rsi-cod-form-embed #_rsi-cod-form-modal-form')
      .forEach(syncForm);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(enhance);
  }

  function init() {
    const root = document.querySelector('main') || document.body;
    new MutationObserver(schedule).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('load', schedule, { once: true });
    enhance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();